import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Script from 'next/script';

import googleOneTapClasses from './googleOneTapConnect.module.css';

const defaultProps = {
  showDisplayOr: true,
};

const GoogleOneTap = (props) => {
  const style = {
    position: 'relative',
    top: '0',
    right: '0',
    margin: 'auto',
    zIndex: 999999,
    display: 'block',
  };
  const [displayOr, setDisplayOr] = useState(false);
  const isSignupModalOpen = useSelector((s) => s.modals?.signUp?.open ?? false);

  useEffect(() => {
    return () => {
      // Clean up the remains of Google One Tap when the component is unmounted
      if (window.google) {
        window.google.accounts.id.cancel();
      }
    };
  }, []);

  if (isSignupModalOpen) {
    return null;
  }

  const onScriptReady = () => {
    const googleOneTapOptions = {
      callback: props.onGoogleOneTap,
      cancel_on_tap_outside: false,
      client_id: props.googleClientId,
      prompt_parent_id: 'googleOneTapContainer',
    };

    // Initialize Google One Tap with the provided configuration
    window.google.accounts.id.initialize(googleOneTapOptions);

    // This will attempt to render the Google One Tap dialog. `onNotification`
    // will receive notifications that indicate the status of Google One Tap.
    window.google.accounts.id.prompt((notification) => {
      setDisplayOr(notification.h);
    });
  };

  return (
    <>
      <div style={props.style || style} id="googleOneTapContainer" />
      {displayOr && props.showDisplayOr && (
        <div id="or" className={`container ${googleOneTapClasses.googleOr}`}>
          or
        </div>
      )}
      <Script
        src="https://accounts.google.com/gsi/client"
        strategy="lazyOnload"
        onReady={onScriptReady}
      />
    </>
  );
};

GoogleOneTap.defaultProps = defaultProps;

export default GoogleOneTap;
